"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAILURE = exports.SUCCESS = exports.REQUEST = exports.SAGA = void 0;
var SAGA = 'apiFlow/data/SAGA';
exports.SAGA = SAGA;
var REQUEST = 'apiFlow/data/REQUEST';
exports.REQUEST = REQUEST;
var SUCCESS = 'apiFlow/data/SUCCESS';
exports.SUCCESS = SUCCESS;
var FAILURE = 'apiFlow/data/FAILURE';
exports.FAILURE = FAILURE;